import { Language, QuestionVariant, TranslationData } from "../types";

export interface QuizModule {
  isTrainingQuiz: boolean;
  keywords: Record<Language, string[]>;
  icon: string;
  title: TranslationData;
  desc: TranslationData;
  colors: [string, string, string];
  slides: Array<QuestionVariant>;
  topic: TranslationData;
  isTeacherModeQuiz: boolean;
}

// export const quizModuleIds = [
//   "general",
//   "password",
//   "phone-call-scam",
//   "phone-call-scam-training",
//   "smishing-training",
//   "email",
//   "email-training",
//   "buy-sell",
//   "buy-sell-training",
//   "ai",
//   "mobile-hacked",
//   "data-hacked",
//   "social-media-chat",
//   "social-media-chat-training",
//   "social-medias",
//   "romance-scam",
//   "fake-website",
//   "id-theft",
//   ///*"source-critism"*/,
//   "advert-scam",
//   "investment-scam",
//   "deepfake-images",
// ] as const;
export type QuizModuleId = string;
// (typeof quizModuleIds)[number];

// export const quizModules: Record<QuizModuleId, QuizModule> = {
//   ai: {
//     isTrainingQuiz: false,
//     keywords: {
//       en: ["deepfake", "technology", "manipulation", "video", "synthetic", "reality"],
//       sv: ["deepfake", "teknologi", "manipulering", "video", "syntetisk", "verklighet"],
//     },
//     icon: "👾",
//     title: {
//       sv: "Skydda mot AI-bedrägerier",
//       en: "Protect against AI scams",
//     },
//     desc: {
//       sv: "Lär dig om deepfakes, förfalskade röster och mycket mer.",
//       en: "Learn about deepfakes, faked voices and much more.",
//     },
//     colors: ["#50ED7E", "#00BE54", "#008437"],
//     slides: [
//       "rost-deep-fake",
//       "deepfake-video",
//       "linkedin-katie-jones",
//       "deepfake-effects",
//       "ai-deepfakes-diskussion",
//       "deepfake_malicious_ent",
//     ],
//     topic: { sv: "ai", en: "ai" },
//   },
//   "deepfake-images": {
//     isTrainingQuiz: false,
//     keywords: {
//       en: [
//         "AI generated photos",
//         "fake images",
//         "altered photos",
//         "deepfake technology",
//         "fake portraits",
//       ],
//       sv: ["AI genererade foton", "falska bilder", "förändrade foton", "deepfake teknik"],
//     },
//     icon: "📷",
//     title: {
//       sv: "Lär dig avslöja AI-genererade bilder",
//       en: "Learn how to detect AI-generated images",
//     },
//     desc: {
//       sv: "Du kommer få se en mängd olika bilder där några är äkta och några är AI-genererade. Din uppgift är att upptäcka vilka som är äkta och vilka som är fake.",
//       en: "You will see a variety of images where some are genuine and some are AI-generated. Your task is to determine which ones are real and which ones are fake.",
//     },
//     colors: ["#DCB6DF", "#5956F0", "#1920C7"],
//     slides: [
//       "deepfake-woman-1",
//       "deepfake-laugh-boy",
//       "deepfake-pope",
//       "deepfake-side-laugh",
//       "deepfake-sea-monster",
//       "photo-king-sweden",
//       "einstein-selfie",
//       "obama-laugh",
//       "fake-ancient-aliens",
//       "no-trust-image",
//     ],
//     topic: { sv: "deepfakes", en: "deepfakes" },
//   },
//   general: {
//     isTrainingQuiz: false,
//     keywords: {
//       en: ["privacy", "cybersecurity", "threats", "online", "defense", "protection"],
//       sv: ["integritet", "cybersäkerhet", "hot", "online", "försvar", "skydd"],
//     },
//     icon: "🤖",
//     title: { sv: "Introduktion till digital säkerhet", en: "Introduction to Digital Security" },
//     desc: {
//       sv: "Perfekt för dig som vill komma igång med Nätklok.",
//       en: "Perfect for first time visitors to Nätklok",
//     },
//     colors: ["#E7DA7E", "#ECC345", "#A78408"],
//     slides: [
//       "ateranvandande-av-losenord",
//       "deepfake-sea-monster",
//       "styrkan-pa-ditt-losenord",
//       "bluff-mejl",
//       "email-sakerhet-snack",
//       "ranka-losenord",
//       "samtal-fran-banken",
//     ],
//     topic: { sv: "grunderna", en: "the basics" },
//   },
//   password: {
//     isTrainingQuiz: false,
//     keywords: {
//       en: ["encryption", "authentication", "security", "safe", "hacking", "nätfiske"],
//       sv: ["kryptering", "autentisering", "säkerhet", "skyddad", "hackning", "phishing"],
//     },
//     icon: "🔑",
//     title: { sv: "Bli lösenordsmästare", en: "Become a Password Master" },
//     desc: {
//       sv: "Lär dig hur man gör starka, oknäckbara lösenord.",
//       en: "Learn how to create passwords that are impossible to crack.",
//     },
//     colors: ["#E28484", "#ED2727", "#A70808"],
//     slides: [
//       "stalkers-pa-instagram",
//       "ateranvandande-av-losenord",
//       "styrkan-pa-ditt-losenord",
//       "csgo-skinet",
//       "ranka-losenord",
//       "se-dina-stalkers-app",
//     ],
//     topic: { sv: "lösenord", en: "passwords" },
//   },
//   "phone-call-scam": {
//     isTrainingQuiz: false,
//     keywords: {
//       en: ["fraud", "caller ID", "voice", "impersonation", "telecom", "verification"],
//       sv: [
//         "bedrägeri",
//         "uppringare",
//         "röst",
//         "personifiering",
//         "telekom",
//         "verifiering",
//         "vishing",
//       ],
//     },
//     icon: "☎️",
//     title: {
//       sv: "Skydda mot telefonbedrägerier",
//       en: "Learn how to Protect yourself from Phone Scams",
//     },
//     desc: {
//       sv: "I detta quiz lär du dig skilja mellan rikiga och bedrägerisamtal.",
//       en: "In this quiz you'll learn to tell the difference between real and scam calls.",
//     },

//     colors: ["#40CC3D", "#1BBD18", "#1B8218"],
//     slides: [
//       "besok-hemma",
//       "telefon-befogenhet",
//       "samtal-fran-banken",
//       "kollega-ringer",
//       "uppringnings-legitimering",
//       "vip-event-inbjudan",
//     ],
//     topic: { sv: "telefonbedrägerier", en: "phone call scams" },
//   },
//   "email-training": {
//     isTrainingQuiz: true,
//     keywords: {
//       en: ["spoofing", "attachments", "credentials", "links", "inbox", "sender", "nätfiske"],
//       sv: ["spoofing", "bilagor", "referenser", "länkar", "inkorg", "avsändare", "phishing"],
//     },
//     icon: "📧",
//     title: {
//       sv: "Känn igen alla falska mejl",
//       en: "Practice Detecting Scam Emails",
//     },
//     desc: {
//       sv: "Det här quizzet innehåller en stor mängd sanna och falska email. Du ska avgöra vilka som är från bedragare och vilka som är äkta.",
//       en: "This quiz contains a large amount of real and fake emails. You have to determine which ones are from scammers and which ones are genuine.",
//     },
//     colors: ["#DCB6DF", "#5956F0", "#1920C7"],
//     slides: [
//       "bank-bekraftelse-mejl",
//       "skatteverket-bedrageri",
//       "postnord-bedrageri",
//       "email-vanlig-onlinebutik",
//       "bluff-mejl",
//       "offshore_investment_scam",
//       "email-vanlig-fb-marketplace",
//       "recovery_room_scheme",
//     ],
//     topic: { sv: "bedragerimelj", en: "scam emails" },
//   },
//   email: {
//     isTrainingQuiz: false,
//     keywords: {
//       en: ["malware", "ransomware", "filter", "trust", "reply", "address", "nätfiske"],
//       sv: [
//         "skadlig programvara",
//         "ransomware",
//         "filter",
//         "förtroende",
//         "svara",
//         "adress",
//         "phishing",
//       ],
//     },
//     icon: "📨",
//     title: {
//       sv: "Allt om bedrägerimejl",
//       en: "How to Avoid Scam Emails",
//     },
//     desc: {
//       sv: "Träna på avgöra ifall ett mejl är ett bedrägeri eller inte.",
//       en: "Practice telling the difference between real and scam emails.",
//     },
//     colors: ["#9E50ED", "#5F00BE", "#420084"],
//     slides: [
//       "postnord-bedrageri",
//       "email-sakerhet-snack",
//       "bluff-mejl",
//       "para-ihop-begrepp",
//       "tryckt-lank",
//       "email-vanlig-fb-marketplace",
//     ],
//     topic: { sv: "bedrägerimejl", en: "scam emails" },
//   },
//   "buy-sell": {
//     isTrainingQuiz: false,
//     keywords: {
//       en: ["transactions", "market", "payment", "trustworthy", "goods", "reviews", "nätfiske"],
//       sv: [
//         "transaktioner",
//         "marknad",
//         "betalning",
//         "tillförlitlig",
//         "varor",
//         "recensioner",
//         "phishing",
//       ],
//     },
//     icon: "🛍️",
//     title: {
//       sv: "Köp och sälj säkert",
//       en: "Buy and Sell Securely",
//     },
//     desc: {
//       sv: "Lär dig att handla online på ett säkert sätt.",
//       en: "Learn how to shop online securely.",
//     },
//     colors: ["#ED7F50", "#BE5100", "#844200"],
//     slides: [
//       "marketplace",
//       "frakt-satt-blocket",
//       "sms-vanlig-fb-marketplace-laptop",
//       "konstig-hemsida",
//       "UPS-mejl",
//       "valj-ratt-prioritet-kop-scam",
//     ],

//     topic: { sv: "e-handel", en: "shopping online" },
//   },

//   "buy-sell-training": {
//     isTrainingQuiz: true,
//     keywords: {
//       en: ["e-commerce", "seller", "buyer", "feedback", "deliveries", "returns"],
//       sv: ["e-handel", "säljare", "köpare", "feedback", "leveranser", "returer"],
//     },
//     icon: "🛒",
//     title: {
//       sv: "Förhindra köp-och-säljbedrägerierna",
//       en: "Practice Detecting E-commerce Scams",
//     },
//     desc: {
//       sv: "Få praktisk träning i att hantera online-transaktioner säkert.",
//       en: "Get hands-on training in handling online transactions securely.",
//     },
//     colors: ["#5089ED", "#0048BE", "#003084"],
//     slides: [
//       "marketplace",
//       "email-bluff-blocket-sakerhet",
//       "sms-vanlig-fb-marketplace-laptop",
//       "email-bluff-fb-marketplace-kopare",
//       "sms-bluff-blocket-overskott",
//       "sms-bluff-blocket-bil",
//       "valj-ratt-prioritet-kop-scam",
//       "sms-vanlig-blocket",
//       "email-fb-marketplace",
//       "sms-bluff-blocket",
//       "frakt-satt-blocket",
//     ],

//     topic: { sv: "e-handel", en: "shopping online" },
//   },

//   "mobile-hacked": {
//     isTrainingQuiz: false,
//     keywords: {
//       en: ["malware", "app", "spyware", "device", "breach", "security"],
//       sv: ["skadlig programvara", "app", "spyware", "enhet", "intrång", "säkerhet"],
//     },
//     icon: "📱",
//     title: {
//       sv: "Är din mobil hackad?",
//       en: "Is Your Mobile Hacked?",
//     },
//     desc: {
//       sv: "Upptäck tecken på att din mobil kan vara hackad.",
//       en: "Discover signs that your mobile may be hacked.",
//     },
//     colors: ["#ED5057", "#BE0014", "#84000D"],
//     slides: [
//       "hackad-mobiltelefon",
//       "telefon-hackad-atgarder",
//       "hackad-mobile-meddelande-skickat",
//       "ar-mobilen-hackad-sms",
//       "hackad-mobil-inloggningsförsök",
//       "osynlig-hack-app",
//       "mobil-hackad-router",
//     ],
//     topic: { sv: "mobilvirus", en: "mobile phone viruses" },
//   },
//   "data-hacked": {
//     isTrainingQuiz: false,
//     keywords: {
//       en: ["database", "cloud", "encryption", "firewall", "breach", "network"],
//       sv: ["databas", "moln", "kryptering", "brandvägg", "intrång", "nätverk"],
//     },
//     icon: "🔓",
//     title: {
//       sv: "Förhindra dataintrång",
//       en: "Fight back against the hackers",
//     },
//     desc: {
//       sv: "Lär dig att minimera risken för dataintrång.",
//       en: "Learn to  minimize the risk of being hacked.",
//     },
//     colors: ["#50EDB4", "#00BE7F", "#008452"],
//     slides: [
//       "anstallda-procent-intrang",
//       "foretag-steg-intrang",
//       "om-du-inte-anvander-vpn",
//       "ditt-hem-har-blivit-smart",
//       "vpn-for-offentliga-natverk",
//       "hittat-en-intressant-enhet",
//       "radgivning-kompis-foretag",
//     ],
//     topic: { sv: "dataintrång", en: "hacks" },
//   },
//   "social-media-chat": {
//     isTrainingQuiz: false,
//     keywords: {
//       en: ["message", "impersonation", "profile", "trust", "messenger", "verification"],
//       sv: ["meddelande", "personifiering", "profil", "förtroende", "budbärare", "verifiering"],
//     },
//     icon: "💬",
//     title: {
//       sv: "Försvara dig mot chatbedragare",
//       en: "Protect yourself against the chat scammers",
//     },
//     desc: {
//       sv: "Lär dig undvika bedragare på messenger, whatsapp och fler.",
//       en: "Learn how to avoid scammers on messenger, whatsapp and more.",
//     },
//     colors: ["#EDB450", "#BE7F00", "#845200"],
//     slides: [
//       "meddelande-fran-kompis",
//       "meddelande-fran-barnbarn",
//       "meddelande-fran-dolt-nummer",
//       "konstig-video-fran-kompis",
//       "sms-erbjudande-fodelsedag",
//       "romans-bedrageri-kompis",
//       "tryckt-lank",
//     ],
//     topic: { sv: "chatt", en: "chat" },
//   },
//   "social-media-chat-training": {
//     isTrainingQuiz: true,
//     keywords: {
//       en: ["interaction", "red flags", "consistency", "links", "chatbot", "real-time"],
//       sv: ["interaktion", "varningstecken", "konsekvens", "länkar", "chattbot", "real-tid"],
//     },
//     icon: "👥",
//     title: {
//       sv: "Förhindra bedrägerier på sociala medier",
//       en: "Practice detecting scam messages on social medias",
//     },
//     desc: {
//       sv: "Få utbildning i att navigera och skydda dig själv på sociala medier.",
//       en: "Get training in navigating and protecting yourself on social media.",
//     },
//     colors: ["#ED50C4", "#BE0090", "#840062"],
//     topic: { sv: "chatt", en: "chat" },
//     slides: [
//       "meddelande-fran-kompis",
//       "meddelande-fran-barnbarn",
//       "meddelande-fran-dolt-nummer",
//       "konstig-video-fran-kompis",
//       "sms-erbjudande-fodelsedag",
//       "romans-bedrageri-kompis",
//     ],
//   },
//   "social-medias": {
//     isTrainingQuiz: false,
//     keywords: {
//       en: ["platform", "post", "friend request", "likes", "share", "privacy settings"],
//       sv: ["plattform", "inlägg", "vännförfrågan", "gillar", "dela", "sekretessinställningar"],
//     },
//     icon: "🌐",
//     title: {
//       sv: "Säkerhet på Sociala Medier",
//       en: "Security on Social Media",
//     },
//     desc: {
//       sv: "Lär dig hur du skyddar din information på olika sociala medieplattformar.",
//       en: "Learn how to protect your information on various social media platforms.",
//     },
//     colors: ["#50A6ED", "#005EBE", "#003F84"],
//     topic: { sv: "sociala medier", en: "social media" },
//     slides: [
//       "meddelande-fran-kompis",
//       "konstig-video-fran-kompis",
//       "romans-bedrageri-kompis",
//       "se-dina-stalkers-app",
//     ],
//   },
//   "romance-scam": {
//     isTrainingQuiz: false,
//     keywords: {
//       en: ["love scam", "online dating scam", "catfishing", "fake profiles", "relationship fraud"],
//       sv: ["kärleksbedrägeri", "online dejting bedrägeri", "falska profiler", "relationssvindel"],
//     },
//     icon: "💔",
//     title: {
//       sv: "Romansbedragare",
//       en: "Romance Scams",
//     },
//     desc: {
//       sv: "Identifiera och skydda dig mot romansbedragare.",
//       en: "Identify and protect yourself from romance scams.",
//     },
//     colors: ["#ED5066", "#BE0019", "#840011"],
//     topic: { sv: "romansbedrägerier", en: "romance scams" },
//     slides: [
//       "romans-scam-sms2",
//       "romans-bedrageri-kompis",
//       "romans-scam-sms",
//       "romansbedragare-pengar-sprak",
//     ],
//   },
//   "fake-website": {
//     isTrainingQuiz: false,
//     keywords: {
//       en: [
//         "fraudulent website",
//         "phishing",
//         "fake domain",
//         "website spoofing",
//         "malicious website",
//       ],
//       sv: ["falsk webbplats", "phishing", "falsk domän", "webbplats spoofing", "skadlig webbplats"],
//     },
//     icon: "🕸️",
//     title: {
//       sv: "Surfa säkert",
//       en: "Safe Surfing",
//     },
//     desc: {
//       sv: "Lär dig att identifiera och undvika falska webbplatser.",
//       en: "Learn to identify and avoid fake websites.",
//     },
//     colors: ["#ED8050", "#BE5700", "#843C00"],
//     topic: { sv: "bedrägerihemsidor", en: "scam websites" },
//     slides: [
//       "elektronik",
//       "sokmotorn-piggy",
//       "konstig-lank",
//       "streama-annanstans",
//       "tryckt-lank",
//       "konstig-hemsida-outlook",
//     ],
//   },
//   "id-theft": {
//     isTrainingQuiz: false,
//     keywords: {
//       en: [
//         "identity fraud",
//         "personal information theft",
//         "credit card theft",
//         "fake identity",
//         "stolen identity",
//       ],
//       sv: ["identitetsbedrägeri", "personuppgiftsstöld", "kreditkortsstöld", "falsk identitet"],
//     },
//     icon: "🔐",
//     title: {
//       sv: "Identitetsstöld",
//       en: "Identity Theft",
//     },
//     desc: {
//       sv: "Skydda dig mot identitetsstöld och lär dig att upptäcka tecken på att du själv blivit utsatt.",
//       en: "Protect yourself against identity theft and learn to detect signs that you've become a victim yourself.",
//     },
//     colors: ["#506AED", "#0043BE", "#002984"],
//     topic: { sv: "Identitet", en: "Identity" },
//     slides: ["olast-enhet", "vilka-ar-id-kap", "spoofing-lardom", "konstig-post"],
//   },

//   /*"source-critism": {
//     isTrainingQuiz: false,
//     keywords: {sv: "", },
//     icon: "🔍",
//     title: {
//       sv: "Källkritik",
//       en: "Source Criticism",
//     },
//     desc: {
//       sv: "Utveckla dina färdigheter i källkritik och i att undvika desinformation.",
//       en: "Develop your source criticism skills and ability to avoid disinformation.",
//     },
//     colors: ["#50ED7E", "#00BE54", "#008437"],
//     topic: { sv: "källkritik", en: "source criticism" },
//     slides: ["sokmotorn-piggy"],
//   },*/
//   "advert-scam": {
//     isTrainingQuiz: false,
//     keywords: {
//       en: ["fake ads", "online ad scams", "fraudulent advertisements", "misleading ads"],
//       sv: ["falska annonser", "online annons bedrägerier", "bedrägliga annonser"],
//     },
//     icon: "🎭",
//     title: {
//       sv: "Annonsbedrägerier",
//       en: "Advertisement Scams",
//     },
//     desc: {
//       sv: "Lär dig att identifiera och undvika annonsbedrägerier.",
//       en: "Learn to identify and avoid advertisement scams.",
//     },
//     colors: ["#ED5050", "#BE0000", "#840000"],
//     topic: { sv: "annonsbedrägerier", en: "advertisement scams" },
//     slides: [
//       "rapportera-annonsbedrageri",
//       "google-image-search-advert",
//       "rental-scam-precautions",
//       "advert-rush-sale",
//       "advanced-payment-advert-scams",
//     ],
//   },
//   "investment-scam": {
//     isTrainingQuiz: false,
//     keywords: {
//       en: [
//         "financial fraud",
//         "ponzi scheme",
//         "fake investments",
//         "fraudulent schemes",
//         "money scams",
//       ],
//       sv: ["finansiellt bedrägeri", "ponzi-schema", "falska investeringar", "bedrägliga scheman"],
//     },
//     icon: "💸",
//     title: {
//       sv: "Investeringsbedrägerier",
//       en: "Investment Scams",
//     },
//     desc: {
//       sv: "Skydda dina pengar och lär dig att upptäcka investeringsbedrägerier.",
//       en: "Protect your money and learn to detect investment scams.",
//     },
//     colors: ["#78ED50", "#4FBE00", "#358400"],
//     topic: { sv: "investeringsbedrägerier", en: "investment scams" },
//     slides: [
//       "crypto",
//       "boiler-room",
//       "digital_investment_scams",
//       "offshore_investment_scam",

//       "recovery_room_scheme",
//     ],
//   },
//   "phone-call-scam-training": {
//     isTrainingQuiz: true,
//     keywords: {
//       en: ["fraudulent calls", "scam calls", "vishing", "fake bank calls", "unsolicited calls"],
//       sv: ["bedrägliga samtal", "scam samtal", "vishing", "falska bank samtal"],
//     },
//     icon: "📞",
//     title: {
//       sv: "Förhindra telefonbedrägerierna",
//       en: "Practice Detecting Phone Call Scam",
//     },
//     desc: {
//       sv: "Arbeta med en mängd frågor om telefonsamtalsbedrägerier. Öva tills du känner dig säker.",
//       en: "Work through a plethora of questions on phone call scams. Practice until you feel confident.",
//     },
//     colors: ["#ED9050", "#BE6400", "#844400"],
//     slides: [
//       "polis-rostmeddelande",
//       "betalningsmisslyckande-meddelande",
//       "bank-samtal",
//       "lottovinst-meddelande",
//       "kollega-ringer",
//       "vip-event-inbjudan",
//       "samtal-fran-banken",
//       "skatteverket-samtal",
//       "suspekt-jobberbjudande",
//     ],

//     topic: { sv: "Telefonsamtal", en: "Phone Call" },
//   },
//   "smishing-training": {
//     isTrainingQuiz: true,
//     keywords: {
//       en: [
//         "text scams",
//         "sms phishing",
//         "fraudulent messages",
//         "fake sms alerts",
//         "unsolicited texts",
//       ],
//       sv: ["textmeddelande bedrägerier", "sms-phishing", "bedrägliga meddelanden"],
//     },
//     icon: "📲",
//     title: {
//       sv: "Förhindra smsbedrägerierna",
//       en: "Protect Yourself Against Text Message Scams",
//     },
//     desc: {
//       sv: "Gå igenom en mängd frågor kring smishing. Öva upprepade gånger för att förstå och förhindra det.",
//       en: "Go through a range of questions on smishing. Practice repetitively to understand and prevent it.",
//     },
//     colors: ["#50B3ED", "#0073BE", "#004E84"],
//     slides: [
//       "sms-bedrageri",
//       "sms-vanlig-google",
//       "marketplace",
//       "romans-scam-sms2",
//       "sms-bedrageri-polis",
//       "sms-fb-marketplace-laptop",
//       "boiler-room",
//       "sms-bedrageri-myndighet",
//       "romans-scam-sms",
//       "advert-rush-sale",
//     ],
//     topic: { sv: "Smishing", en: "Smishing" },
//   },
// };

const prod = true;
const url = prod ? "https://main--natklok-mono.netlify.app" : "http://localhost:4200";

export const articlesObj: Array<{ id: QuizModuleId; articles: string; iframe: string }> = [
  {
    id: "deepfake-images",
    articles: ``,
    iframe: `<iframe height='800px' width='100%' src='${url}/minimized-questions?questionIds=deepfake-woman-1,deepfake-laugh-boy,fake-ancient-aliens,no-trust-image' style='border:none; border-radius: 2px;'></iframe>`,
  },
  {
    id: "buy-sell",
    articles: `/aktuella-brott/bedragare-vid-forsaljning-pa-facebook-marketplace/	33,035
  /aktuella-brott/bedragare-vid-forsaljning-av-varor-pa-blocket/	1,823
  /sakerhetsguider/handla-sakert-online/	1,062
  /aktuella-brott/varning-for-fortsatta-bedragerier-via-fb-marketplace/	881
  /aktuella-brott/varning-for-blocketbedragare/	278`,
    iframe: `<iframe height='540px' width='100%' src='${url}/minimized-questions?questionIds=sms-bluff-blocket-bil,sms-bluff-blocket-overskott,marketplace' style='border:none; border-radius: 2px;'></iframe>`,
  },
  {
    id: "mobile-hacked",
    articles: `/artiklar/sa-vet-du-om-din-mobiltelefon-blivit-hackad/	18,183
    /sakerhetsguider/mobilsakerhet/	404
    /aktuella-brott/kivra-varnar-for-telefonbedragerier/	401`,
    iframe: `<iframe height='540px' width='100%' src='${url}/minimized-questions?questionIds=chatt-om-hackad,hackad-mobile-meddelande-skickat,telefon-hackad-atgarder' style='border:none; border-radius: 2px;'></iframe>`,
  },
  {
    id: "data-hacked",
    articles: `/ta-hjalp-direkt/dataintrang/	1,222
  /sakerhetsguider/kryptering-skyddar-din-dator-fran-intrang/	355`,
    iframe: `<iframe height='540px' width='100%' src='${url}/minimized-questions?questionIds=foretag-steg-intrang,radgivning-kompis-foretag,mobil-hackad-router' style='border:none; border-radius: 2px;'></iframe>`,
  },
  {
    id: "social-medias",
    articles: `/sakerhetsguider/tiktok/	2,901
    /sakerhetsguider/instagram-och-bedragare/	2,359
    /sakerhetsguider/bedragare-pa-facebook/	1,614
    /sakerhetsguider/risker-och-sakerhet-pa-snapchat/	1,228
    /sakerhetsguider/discord/	966`,
    iframe: `<iframe height='540px' width='100%' src='${url}/minimized-questions?questionIds=meddelande-fran-kompis,se-dina-stalkers-app,konstig-video-fran-kompis' style='border:none; border-radius: 2px;'></iframe>`,
  },
  {
    id: "romance-scam",
    articles: `/sakerhetsguider/catfishing-och-romansbedragerier/	2,335
/artiklar/sa-har-stjaler-bedragaren-ditt-hjarta-och-dina-pengar/	319`,
    iframe: `<iframe height='540px' width='100%' src='${url}/minimized-questions?questionIds=romans-scam-sms,romansbedragare-pengar-sprak' style='border:none; border-radius: 2px;'></iframe>`,
  },
  {
    id: "fake-website",
    articles: `/sakerhetsguider/falska-webbsidor/	2,159`,

    iframe: `<iframe height='540px' width='100%' src='${url}/minimized-questions?questionIds=konstig-lank,streama-annanstans,tryckt-lank' style='border:none; border-radius: 2px;'></iframe>`,
  },

  {
    id: "phone-call-scam",
    articles: `/aktuella-brott/polisen-varnar-for-bluffsamtal/	1,655
/aktuella-brott/polisen-varnar-for-sms-fran-ditt-barn/	1,011
/sakerhetsguider/vishing/	913
/aktuella-brott/seb-varnar-for-falska-sms/	644`,
    iframe: `<iframe height='540px' width='100%' src='${url}/minimized-questions?questionIds=bank-samtal,lottovinst-meddelande,skatteverket-samtal' style='border:none; border-radius: 2px;'></iframe>`,
  },
  {
    id: "id-theft",
    articles: `/sakerhetsguider/id-kapning/	1,486
  /ta-hjalp-direkt/id-kapning/	674`,
    iframe: `<iframe height='540px' width='100%' src='${url}/minimized-questions?questionIds=vilka-ar-id-kap,konstig-post' style='border:none; border-radius: 2px;'></iframe>`,
  },
  {
    id: "social-media-chat",
    articles: `/aktuella-brott/varning-for-bedragliga-meddelanden-fran-messenger/	15,111
/sakerhetsguider/vem-pratar-du-med-pa-whatsapp/	6,574
/aktuella-brott/varning-for-forsok-till-natfiske-pa-messenger/	281
/aktuella-brott/varning-for-swish-bedragerier/	355`,
    iframe: `<iframe height='540px' width='100%' src='${url}/minimized-questions?questionIds=meddelande-fran-kompis,konstig-video-fran-kompis,sms-erbjudande-fodelsedag' style='border:none; border-radius: 2px;'></iframe>`,
  },

  {
    id: "ai",
    articles: `/sakerhetsguider/stoppa-fake-news-med-kallkritik/	912
    /artiklar/vad-ar-deepfake/	1,808`,
    iframe: `<iframe height='540px' width='100%' src='${url}/minimized-questions?questionIds=rost-deep-fake,deepfake-video,deepfake_malicious_ent' style='border:none; border-radius: 2px;'></iframe>`,
  },

  {
    id: "smishing-training",
    articles: `/aktuella-brott/bankid-varnar-for-en-okning-av-falska-sms/	809
    /aktuella-brott/varning-for-natfiske-phishing-via-sms/	557
    /artiklar/smishing/	339
    /aktuella-brott/varning-for-falska-sms-fran-fraktbolag/	325
    /aktuella-brott/varning-for-sms-bedrageri-som-utnyttjar-dhl/	325`,
    iframe: `<iframe height='540px' width='100%' src='${url}/minimized-questions?questionIds=advert-rush-sale,sms-vanlig-google,marketplace' style='border:none; border-radius: 2px;'></iframe>`,
  },
  {
    id: "investment-scam",
    articles: `/artiklar/sa-har-funkar-kryptovaluta/	376
  /artiklar/investeringsbedragerier-och-bitcoin/	299`,
    iframe: `<iframe height='540px' width='100%' src='${url}/minimized-questions?questionIds=boiler-room,digital_investment_scams' style='border:none; border-radius: 2px;'></iframe>`,
  },
  {
    id: "advert-scam",
    articles: `/sakerhetsguider/annonsbedrageri/	662`,
    iframe: `<iframe height='540px' width='100%' src='${url}/minimized-questions?questionIds=frakt-satt-blocket,UPS-mejl,sms-vanlig-fb-marketplace-laptop' style='border:none; border-radius: 2px;'></iframe>`,
  },
  {
    id: "email",
    articles: `/testa-din-sakerhet/ar-din-mejladress-saker/	599
  /artiklar/phishing/	328`,
    iframe: `<iframe height='600px' width='100%' src='${url}/minimized-questions?questionIds=skatteverket-bedrageri,email-vanlig-fb-marketplace,bank-bekraftelse-mejl' style='border:none; border-radius: 2px;'></iframe>`,
  },
];
